export const VARIATIONS_PER_ROW = {
    default: 2,
    sm: 3,
    md: 4,
};

/**
 * The logo variation card dom unique identifier attribute
 * @type {String}
 */
export const VARIATION_CARD_DOM_ID_ATTRIBUTE = 'data-variation-id';

/**
 * The variation card class name
 */
export const VARIATION_CARD_CLASSNAME = 'logo-variation-card';

/**
 * Engine type to be reported in gig_impression from tag pages
 */
export const INSPIRATION_ENGINE_TYPE = 'Tags';
